export const contact = {
  // Hero
  heroTitle: 'تواصل معنا',
  heroSubtitle: 'هل أنت مستعد لإيجاد الحل المناسب لمشروعك؟ دعنا نتحدث مع مكتبنا الرئيسي في Çorlu.',
  
  // Contact Info
  address: 'العنوان',
  addressValue: 'Şeyh Sinan, Hüsmen Kalfa Sk. No:5/33, 59850 Çorlu/Tekirdağ',
  phone: 'الهاتف',
  phoneValue: '+90 530 095 97 41',
  email: 'البريد الإلكتروني',
  emailValue: 'info@dynamixsteelfiber.com',
  instagram: 'إنستغرام',
  instagramValue: '@dynamixsteelfiber',
  whatsapp: 'واتساب',
  whatsappValue: '+90 530 095 97 41',
  
  // Form
  formTitle: 'أرسل لنا رسالة',
  fullName: 'الاسم الكامل',
  fullNamePlaceholder: 'محمد أحمد',
  companyName: 'اسم الشركة',
  companyNamePlaceholder: 'شركة البناء ABC',
  emailAddress: 'عنوان البريد الإلكتروني',
  emailPlaceholder: 'you@example.com',
  phoneNumber: 'رقم الهاتف',
  phonePlaceholder: '+90 (123) 456-7890',
  message: 'الرسالة',
  messagePlaceholder: 'أخبرنا عن متطلبات مشروعك...',
  required: '*',
  characters: 'حرف',
  sendMessage: 'إرسال رسالة',
  sending: 'جاري الإرسال...',
  
  successMessage: 'شكراً لك! تم إرسال رسالتك بنجاح. سنعود إليك قريباً.',
  errorMessage: 'عذراً، حدث خطأ أثناء إرسال رسالتك. يرجى المحاولة مرة أخرى أو الاتصال بنا مباشرة.',
  
  // Map
  mapTitle: 'موقعنا',
  mapSubtitle: 'قم بزيارة منشأتنا في Çorlu، Tekirdağ',
  
  // Business Hours
  hoursTitle: 'ساعات العمل',
  officeHours: 'ساعات المكتب',
  mondayFriday: 'الاثنين - الجمعة:',
  mondayFridayTime: '8:00 صباحاً - 6:00 مساءً',
  saturday: 'السبت:',
  saturdayTime: '9:00 صباحاً - 2:00 مساءً',
  sunday: 'الأحد:',
  sundayTime: 'مغلق',
  
  productionFacility: 'منشأة الإنتاج',
  productionMF: 'الاثنين - الجمعة:',
  productionMFTime: 'عمليات 24/7',
  productionWeekend: 'عطلة نهاية الأسبوع:',
  productionWeekendTime: 'حسب الطلب',
};

